import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Button.module.scss';
export const Button = ({ label, children, showLabel = true, shape = 'square', variant = 'primary', size = 'small', className, disabled, customWidth, style, href, target, ...props }) => {
    const classes = [
        styles.button,
        styles[`button--${shape}`],
        styles[`button--${variant}`],
        styles[`button--${size}`],
        className,
    ]
        .filter(Boolean)
        .join(' ');
    const mergedStyle = {
        ...(customWidth ? { width: customWidth } : {}),
        ...style,
    };
    const content = showLabel ? (_jsx("span", { className: styles.button__content, children: children ?? label })) : null;
    if (href) {
        const linkProps = props;
        return (_jsx("a", { href: href, target: target, className: classes, style: mergedStyle, ...linkProps, children: content }));
    }
    const buttonProps = props;
    return (_jsx("button", { className: classes, disabled: disabled, style: mergedStyle, ...buttonProps, children: content }));
};
